/**
 * SitemapTab Component
 *
 * Displays discovered sitemap/URL structure for web application seeds.
 * Shows crawled pages, endpoints, and web application structure.
 * Only rendered for seeds with class='webapplication'.
 *
 * @component
 */

import { WebApplicationSitemap } from '@/sections/asset/components/tabs';
import { Seed } from '@/types';

interface SitemapTabProps {
  /** The web application seed to display sitemap for */
  seed: Seed;
}

/**
 * SitemapTab displays web application sitemap/crawl results
 *
 * Wraps the WebApplicationSitemap component from the asset section to show
 * discovered URLs and site structure for web application seeds.
 *
 * @param seed - The seed object (must be class='webapplication')
 */
export function SitemapTab({ seed }: SitemapTabProps) {
  return (
    <WebApplicationSitemap
      asset={{ key: seed.key, identifier: seed.identifier }}
    />
  );
}
